import {
  CarDisclosureContentCode,
  UseDisclosures,
} from "@app/hooks/useDisclosures";
import { PdfReportPage, PdfReportPageProps } from "./PdfReportPage";
import { CarPdfHeading } from "@app/components/PdfHeading";
import { CarPdfMarkdown } from "@app/components/PdfMarkdown";

export interface DisclosuresPdfPageProps {
  disclosures: UseDisclosures;
  pageProps: PdfReportPageProps;
}

export const DisclosuresPdfPage = (props: DisclosuresPdfPageProps) => (
  <PdfReportPage {...props.pageProps}>
    <CarPdfHeading label="Disclosures" style={{ marginBottom: 14 }} />
    <CarPdfMarkdown>
      {props.disclosures.getContent(
        CarDisclosureContentCode.PLANNING_COMPREHENSIVE_DISCLOSURE_MAIN_part_10,
      )}
    </CarPdfMarkdown>
  </PdfReportPage>
);
